{
  "nl": {
    "table": {
      "cells": {
        "storageLocation": {
          "personal": "Mijn Opslag"
        }
      },
      "columns": {
        "access": "Toegangen",
        "author": "Auteur",
        "created": "Aangemaakt op",
        "date": "Datum",
        "deletion": "Verwijderd op",
        "invitedBy": "Uitnodiging van",
        "joinedAt": "Toegetreden op",
        "name": "Naam",
        "projects": "Projecten",
        "school": "School",
        "select": "Selectie",
        "selectAll": "Alles selecteren",
        "status": "Status",
        "progress": "Voortgang",
        "feedback": "Feedback",
        "updatedAt": "Gewijzigd op",
        "updated_at": "Gewijzigd op",
        "folder": "Map",
        "storageLocation": "Opslaglocatie",
        "source": "Bron",
        "responses": "Inleveringen",
        "responsesCount": "Aantal inleveringen",
        "drafts": "Concepten",
        "preCorrections": "Voorkeuringen",
        "title": "Titel",
        "archivedAt": "Gearchiveerd op",
        "description": "Beschrijving",
        "projectsCount": "Projecten"
      },
      "author": {
        "currentUser": "Ik"
      },
      "emptyState": {
        "noContent": "Er konden geen inhoud worden gevonden",
        "noSearchResults": "Geen resultaten voor deze zoekopdracht."
      },
      "rowActions": "Acties"
    }
  }
}
